<template>
  <iframe
    v-if="asset.type === assetsTypes.v360"
    :src="format360Url(asset.url)?.mobile || ''"
    width="100%"
    height="100%"
    class="d3-diamond pointer-events-none"
    frameborder="0"
    @click.stop
  />
  <video
    v-else-if="asset.type === assetsTypes.video"
    :src="asset.url"
    autoplay
    loop
    muted
    playsinline
    class="object-cover"
  />
  <UiLazyImg
    v-else
    :src="asset?.url"
    :alt="asset?.alt || productData?.currentTranslation?.title || 'image'"
    class="bg-product-card-gradient"
    cover
  />
</template>
<script setup lang="ts">
import { assetsTypes, ProductData } from "ecom-types";

interface ImageData {
  alt?: string;
  url: string;
  type?: string;
  listType?: string;
}

defineProps<{
  asset: ImageData;
  productData?: ProductData;
}>();

// TODO: We use this only for DC format360Url(asset.url)?.mobile
function format360Url(view360_url: string) {
  if (!view360_url) {
    return null;
  }
  const urlDesktop = new URL(view360_url);
  const urlMobile = new URL(view360_url);
  const searchParamsDesktop = [
    ["btn", "0"],
    ["v", "6"],
    ["zoomslide", "1"],
    ["z", "1"],
    ["isBorderRadius", "0"],
    ["sr", "100"],
  ];
  const searchParamsMobile = [
    ["btn", "0"],
    ["v", "6"],
    ["zoomslide", "0"],
    ["z", "0"],
    ["isBorderRadius", "0"],
  ];
  searchParamsDesktop.forEach((el) => {
    urlDesktop.searchParams.set(el[0], el[1]);
  });
  searchParamsMobile.forEach((el) => {
    urlMobile.searchParams.set(el[0], el[1]);
  });
  return { desktop: urlDesktop.href, mobile: urlMobile.href };
}
</script>

<style scoped></style>
